import { en } from './en'
import { fr } from './fr'

export const bookADemoNonprofit = { en, fr }
